import { BookModel } from "../BookModel/BookModel";

export class BankModel extends BookModel {
  getBank() {
    return {
      owner: this.get("owner", ""),
      bank_name: this.get("bank_name", ""),
      iban: this.get("iban", ""),
      blz: this.get("blz", ""),
      bic: this.get("bic", ""),
    };
  }
}
